import { Tag } from 'antd';
import styled from 'styled-components';

const jobTypesColorMap = {
	color: {
		'Full Time': '#21c797',
		'Part Time': '#e8bc03',
		'Remote': '#2198c7'
	},
	bgColor: {
		'Full Time': '#D2F8EE',
		'Part Time': '#ffefb0',
		'Remote': '#c8e6ff'
	}
};
export const JobTypeTag = styled(Tag)<{ type: string }>`
	color: ${({ type }) => jobTypesColorMap.color[type]};
	background-color: ${({ type }) => jobTypesColorMap.bgColor[type]};
	padding: 3px 6px;
	border: none;
	margin: 0 2px 2px 0;
	min-width: 70px;
	text-align: center;
`;
